import React, { useContext, useEffect, useState } from "react";
import { Col } from "antd";
import { LoadOnScreen } from "shared-components/Components/OnView/web";
import { PropertySimilarsCards } from "../PropertySimilars/PropertySimilarsCards/web";
import { fetchSearchResults } from "src/services/search";
import { PropertyData } from "src/contexts/PropertyData/PropertyDataProvider";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";

import "../styles.less";

export const PropertyInactive = ({ listing, mode = "auto" }) => {
	const { main_domain } = useContext(ConfigStateContext);
	const [similars, setSimilars] = useState<PropertyData[]>([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setLoading(true);
		const fetchSimilarProperties = async () => {
			const propertyParams = {
				operation_type_id: listing?.inactiveSimilarInfo?.operation_type_id,
				property_type_id: [listing?.inactiveSimilarInfo?.property_type_id],
				minPrice: Math.floor((1 - 0.7) * (listing?.inactiveSimilarInfo?.price || 0)),
				maxPrice: Math.floor((1 + 0.7) * (listing?.inactiveSimilarInfo?.price || 0)),
				locations: [
					...(listing?.inactiveSimilarInfo?.city_id
						? [
								{
									type: "CITY",
									id: listing?.inactiveSimilarInfo?.city_id,
								},
						  ]
						: []),
					...(listing?.inactiveSimilarInfo?.neighborhood_id
						? [
								{
									type: "NEIGHBOURHOOD",
									id: listing?.inactiveSimilarInfo?.neighborhood_id,
								},
						  ]
						: []),
				],
			};

			const projectParams = {
				owner_id: listing?.owner?.id,
				projects: true,
			};

			const data = await fetchSearchResults(
				{
					rows: 10,
					params: listing?.__typename === "Project" ? projectParams : propertyParams,
					page: 1,
					source: 10,
				},
				main_domain
			);
			setSimilars(data?.searchFast?.data);
			setLoading(false);
		};
		fetchSimilarProperties();
	}, [listing]);
	
	if(!similars?.length) return null

	return (
		<div className="property-detail-container">
			<div
				className="pd-main container pd-container pd-main-row">
				{/* In Active Prop Declaimer */}
				{!listing.active && (
					<>
						{((listing.isProject && listing.commercial_units.length > 0) ||
							!listing.isProject) && (
							<Col span={24} className="padding">
								<div className="similar-container">
									<LoadOnScreen listen={!loading}>
										<PropertySimilarsCards
											avoidFetchingSimilars
											initialProperties={similars}
											id={listing?.owner?.id}
											mode={mode}
											title={
												mode === "project"
													? "Proyectos de la constructora"
													: null
											}
											ownerId={mode === "project" ? listing?.owner?.id : null}
										/>
									</LoadOnScreen>
								</div>
							</Col>
						)}
					</>
				)}
				<a
					className="btn-primary"
					href={"/venta/casas-y-apartamentos"}
					style={{
						margin: "16px auto 0",
						padding: "0 44px",
						width: "fit-content",
					}}>
					Ver más propiedades
				</a>
			</div>
		</div>
	);
};
